import styled from "styled-components";

export const StylesBookingModal = styled.div`
  .form-input,
  .react-datepicker-wrapper {
    width: 100%;
  }
  .form-label {
    color: #354052;
    font-weight: 600;
    font-size: 0.9rem;
    margin-bottom: 2px;
  }
`;
